const btnBurger = document.querySelector('.header__burger');
const body = document.querySelector('body');
const headerNav = document.querySelector('.nav');
const headerBlackout = document.querySelector('.header__blackout');

if (btnBurger) {
  btnBurger.addEventListener('click', () => toggleMenu());
}

function toggleMenu() {
  body.classList.toggle('overflow');
  headerNav.classList.toggle('nav_active');
  btnBurger.classList.toggle('header__burger_close');
  headerBlackout.classList.toggle('header__blackout_active');
}